import React, { useEffect } from 'react'
import { injectIntl, Link } from 'gatsby-plugin-intl'
import styled from 'styled-components'
import { colors } from 'utils/utils'
import useScrollBlock from '../hooks/useScrollBlock'

export default injectIntl(props => {	
	const {openCookies, cookieBarInfo, manage, acceptAll, policyLink} = props
    const [ blockScroll, allowScroll ] = useScrollBlock()

	useEffect(() => {
        if(openCookies) {
            blockScroll()
        } else {
            allowScroll()
        }
    },[ blockScroll, allowScroll, openCookies])

    return (
		<>
			<CookieOverlay className={openCookies ? '' : 'closed'}/>
			<CookieBar className={openCookies ? '' : 'closed'}>
				<CookieBarWrapper>
					<BarText>{cookieBarInfo.text}</BarText>
					<BarFooter>
						<Link to={`/${policyLink.node_locale}/${policyLink.href}`}>
							{policyLink.value}
						</Link>
						<BarButtonBlock>
							<ManageButton onClick={manage}>{cookieBarInfo.manageButton}</ManageButton>
							<AcceptButton onClick={acceptAll}>{cookieBarInfo.acceptButton}</AcceptButton>
						</BarButtonBlock>
					</BarFooter>
				</CookieBarWrapper>
			</CookieBar>
		</>	
    )
})

const CookieOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	height: stretch;
	border: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 21474836487!important;

	&.closed {
		display: none;
	}
`

const CookieBar = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	min-height: 120px;
	padding: 1rem 2rem;
	background-color: rgba(12,0,38,0.92)!important;
	color: ${colors.quinary};
	z-index: 2147483648!important;
	transition: bottom .5s ease-in-out;

	&.closed {
		bottom: -250px;
	}
`

const CookieBarWrapper = styled.div`
	margin: auto;
	width: 100%;
	max-width: 1280px;
`

const BarText = styled.span`	
`

const BarFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: 1rem;

	a {
		color: ${colors.quinary};
		display: block;
		align-self: center;
		margin: 1rem 1rem 1rem 0;
	}
`

const BarButtonBlock = styled.div`
	button {
		border: 0;
		color: ${colors.quinary};
		padding: .5rem 1rem;
		border-radius: .2rem;
		margin: 1rem;
		cursor: pointer;
		background-color: ${colors.secondary};
		&:first-of-type {
			margin-left: 0;
		}
		&:last-of-type {
			margin-right: 0;
		}
	}
`

const ManageButton = styled.button`
`

const AcceptButton = styled.button`
`